/**
 * COURE.HUB.DS.USSD.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ResponseType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export const ResponseType = {
    NUMBER_1: 1 as ResponseType,
    NUMBER_2: 2 as ResponseType,
    NUMBER_3: 3 as ResponseType,
    NUMBER_4: 4 as ResponseType,
    NUMBER_5: 5 as ResponseType,
    NUMBER_6: 6 as ResponseType,
    NUMBER_7: 7 as ResponseType,
    NUMBER_8: 8 as ResponseType,
    NUMBER_9: 9 as ResponseType
};